import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main' // import the instance
import axios from 'axios' // remove comment if yu needed
import checkResponse from '@/utils/checkResponse'
import Crud from '../crud'
import Catalogs from '../catalogs'

const model = (payload) => ({
  labels: payload.labels
})
var crud = new Crud('LabelGroups', model)
var catalogs = new Catalogs()

Vue.use(Vuex)

const state = {
  ...crud.state,
  ...catalogs.state,
  catalog: {},
  syncro: false,
  order: {},
  transferFolio: '',
  orderDetails: [],
  tabSheet: [],
  convertedProducts: [],
  labelGroups: [],
  labels: [],
  shipments: [],
  transfers: [],
  isProductsModalVisible: false,
  isOrdersModalVisible: false,
  isTransfersModalVisible: false,
  isProductsByExcelModalVisible: false,
  isProductsByOrderModalVisible: false,
  fromOrder: false
}

const mutations = {
  ...crud.mutations,
  ...catalogs.mutations,
  CONVERT_TO_ARRAY (state, payload) {
    const keys = ['code', 'quantity', 'price', 'alternative_code']
    const convertedProducts = payload.map(item => {
      const obj = {}
      keys.forEach((key, index) => {
        obj[key] = item[index]
      })
      return obj
    })
    state.convertedProducts = convertedProducts
  },
  ADD_LABEL (state, payload) {
    payload.forEach(element => {
      const idx = state.labels.findIndex(u => u.code === element.code)
      if (idx >= 0) {
        const itemNew = state.labels[idx]
        itemNew.quantity = parseInt(itemNew.quantity) + 1
        Vue.set(state.labels, idx, itemNew)
      } else {
        var itemNew = element
        itemNew.product_id = itemNew.id
        itemNew.quantity = 1
        itemNew = { ...itemNew, products_by_label: 1 }
        state.labels.push(itemNew)
      }
    })
  },
  ADD_LABELS_FROM_SHIPMENT (state, payload) {
    state.fromOrder = true
    payload.data.forEach(element => {
      const itemNew = {
        ...element,
        quantity: parseFloat(1),
        products_by_label: parseFloat(element.quantity).toFixed(2)
      }
      state.labels.push(itemNew)
    })
  },
  ADD_LABELS_FROM_TRANSFER (state, payload) {
    payload.data.forEach(element => {
      const itemNew = {
        product_code_display: element.product_code,
        product_display: element.product_name,
        product_id: element.product_id,
        quantity: parseFloat(1),
        products_by_label: parseFloat(element.quantity_transfer).toFixed(2)
      }
      state.labels.push(itemNew)
    })
  },
  SET_TRANSFER_FOLIO (state, payload) {
    state.transferFolio = payload
  },
  ADD_LABELS_FROM_ORDER (state, payload) {
    payload.response.forEach((element, index) => {
      state.labels.push({
        order_folio: state.order.folio,
        code: element.code,
        name: element.name,
        description: element.description,
        product_id: element.id,
        product_code_display: element.product_code_display,
        product_display: element.product_display,
        quantity: payload.order[index].quantity,
        quantity_from_order: payload.order[index].quantity,
        quantity_validation: false,
        by_label_validation: false,
        products_by_label: payload.order[index].products_by_label
      })
    })
  },
  REMOVE_LABEL (state, payload) {
    const idx = state.labels.findIndex(u => u.code === payload.code)
    if (idx >= 0) {
      Vue.delete(state.labels, idx)
    }
  },
  SET_PRODUCTS_MODAL_VISIBLE (state, payload) {
    state.isProductsModalVisible = payload
  },
  SET_ORDER (state, payload) {
    state.order = payload.data[0].order
    state.orderDetails = payload.data[0].details
  },
  SET_ORDER_DETAILS (state, payload) {
    state.orderDetails = payload.data
  },
  SET_SHIPMENTS (state, payload) {
    state.shipments = payload.data
  },
  SET_TRANSFERS (state, payload) {
    state.transfers = payload.data
  },
  SET_SHIPMENTS_MODAL_VISIBLE (state, payload) {
    state.isOrdersModalVisible = payload
  },
  SET_TRANSFERS_MODAL_VISIBLE (state, payload) {
    state.isTransfersModalVisible = payload
  },
  CLEAR_LABELS (state) {
    state.labels = []
    state.fromOrder = false
  },
  SET_PRODUCTS_BY_EXCEL_MODAL_VISIBLE (state, payload) {
    state.isProductsByExcelModalVisible = payload
  },
  SET_PRODUCTS_BY_ORDER_MODAL_VISIBLE (state, payload) {
    state.isProductsByOrderModalVisible = payload
  },
  SET_FAMILIES (state, payload) {
    state.catalog['product-families'] = payload
  },
  SET_LABELS_BY_EXCEL (state, payload) {
    payload.response.forEach((element, index) => {
      state.labels.push({
        code: element.code,
        name: element.name,
        description: element.description,
        product_id: element.id,
        product_code_display: element.product_code_display,
        product_display: element.product_display,
        quantity: payload.spreadsheet[index].quantity,
        quantity_from_order: payload.spreadsheet[index].quantity,
        quantity_validation: false,
        by_label_validation: false,
        products_by_label: payload.spreadsheet[index].products_by_label
      })
    })
  },
  SET_SYNCRO (state, payload) {
    state.syncro = payload
  }
}

const actions = {
  ...crud.actions,
  ...catalogs.actions,
  convertToArrayOfObjects ({ commit }, payload) {
    commit('CONVERT_TO_ARRAY', payload)
  },
  cleanSpreadSheet ({ commit }, payload) {
    commit('CLEAN_SPREAD_SHEET')
  },
  async findProduct ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`products?code=${payload.code}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        const label = response.data.data
        if (label.length) commit('ADD_LABEL', response.data.data)
        return label.length
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async findProductByDescription ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`products?description=*${payload.description}*`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PRODUCTS', response.data.data)
        commit('SET_PRODUCTS_MODAL_VISIBLE', true)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async getShipments ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`shipments/list?status_id=1`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SHIPMENTS', response.data)
        commit('SET_SHIPMENTS_MODAL_VISIBLE', true)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async getTransfers ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`transfers?page=${payload.page}${payload.filters}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_TRANSFERS', response.data)
        commit('SET_TRANSFERS_MODAL_VISIBLE', true)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printTag ({ commit }, payload) {
    app.$Progress.start()
    try {
      const customerCode = payload.customer_code ? `&customer_code=${payload.customer_code}` : ''
      const transferFolio = payload.transfer_folio ? `&transfer_folio=${payload.transfer_folio}` : ''
      window.open(`${axios.defaults.baseURL}/label-groups/tag?group_id=${payload.id}${customerCode}${transferFolio}`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  deleteLabel ({ commit }, payload) {
    commit('REMOVE_LABEL', payload)
  },
  setProductsModalVisible ({ commit }, payload) {
    commit('SET_PRODUCTS_MODAL_VISIBLE', payload)
  },
  setOrdersModalVisible ({ commit }, payload) {
    commit('SET_ORDERS_MODAL_VISIBLE', payload)
  },
  setProductsByShipmentModalVisible ({ commit }, payload) {
    commit('SET_SHIPMENTS_MODAL_VISIBLE', payload)
  },
  setModalTransferHidden ({ commit }) {
    commit('SET_TRANSFERS_MODAL_VISIBLE', false)
  },
  setProductsByExcelModalVisible ({ commit }, payload) {
    commit('SET_PRODUCTS_BY_EXCEL_MODAL_VISIBLE', payload)
  },
  setProductsByOrderModalVisible ({ commit }, payload) {
    commit('SET_PRODUCTS_BY_ORDER_MODAL_VISIBLE', payload)
  },
  addLabels ({ commit }, payload) {
    commit('ADD_LABEL', payload)
  },
  async addLabelsFromShipments ({ commit }, payload) {
    commit('SET_LOADING', true, { root: true })
    const query = payload.map(shipmentId => `shipment_id[]=${shipmentId}`).join('&')
    try {
      const response = await axios.get(`shipment-details?${query}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_LABELS_FROM_SHIPMENT', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addLabelsFromTransfers ({ commit }, payload) {
    commit('SET_LOADING', true, { root: true })
    const query = payload.ids.map(transferId => `transfer_id[]=${transferId}`).join('&')
    try {
      const response = await axios.get(`transfer-details?${query}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_TRANSFER_FOLIO', payload.folio)
        commit('ADD_LABELS_FROM_TRANSFER', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async getOrder ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    const branchParam = `?branch_id=${payload.branch_id}`
    try {
      const response = await axios.get(`/contpaq/orders/${payload.order_folio}${branchParam}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        if (response.data.isSuccess) {
          if (response.data.data.length === 0) {
            commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'Orden no encontrada', text: 'Orden no encontrada con el folio: ' + payload.order_folio + (!payload.isSFS ? ', sucursal: ' + payload.branch_name : '') }, { root: true })
          } else {
            commit('SET_ORDER', response.data)
          }
        } else {
          commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'Error Contpaq', text: response.data.message }, { root: true })
        }
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
      app.$Progress.finish()
    }
  },
  clearLabels ({ commit }) {
    commit('CLEAR_LABELS')
  },
  setLoader ({ commit }, payload) {
    commit('SET_LOADING', payload, { root: true })
  },
  async validateProducts ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`products/validate-by-codes`, { details: payload.convertedDetails })
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        if (response.data[0]) {
          commit('SET_LABELS_BY_EXCEL', { response: response.data[1], spreadsheet: payload.convertedDetails })
        } else {
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'products.not_found_title', text: 'Producto no encontrado: ' + response.data[2] }, { root: true })
        }
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async validateProductsFromOrder ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`products/validate-by-codes`, { details: payload.convertedDetails })
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        if (response.data[0]) {
          commit('ADD_LABELS_FROM_ORDER', { response: response.data[1], order: payload.convertedDetails })
        } else {
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'products.not_found_title', text: 'Producto no encontrado: ' + response.data[2] }, { root: true })
        }
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async checkSyncro ({ commit }) {
    app.$Progress.start()
    try {
      const response = await axios.get(`/contpaq/syncro`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        const data = typeof response.data === 'object' ? null : response.data

        const actions = {
          false: () => {
            commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.syncro' }, { root: true })
          },
          true: () => {
            commit('SET_SYNCRO', data)
          },
          null: () => {
            commit('SET_SYNCRO', false)
            commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.contpaq', text: 'errors.syncro_request_error' }, { root: true })
          },
          default: () => {
            commit('SET_SYNCRO', false)
            commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.connection_error' }, { root: true })
          }
        };

        (actions[data] || actions.default)()
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async syncContpaqOrders ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`contpaq/orders`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {

      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  }
}

const getters = {
  ...crud.getters,
  ...catalogs.getters,
  syncro: state => state.syncro,
  tabSheet: state => state.tabSheet,
  convertedProducts: state => state.convertedProducts,
  labelGroups: state => state.labelGroups,
  labels: state => state.labels,
  order: state => state.order,
  orderDetails: state => state.orderDetails,
  isProductsModalVisible: state => state.isProductsModalVisible,
  shipments: state => state.shipments,
  transfers: state => state.transfers,
  transferFolio: state => state.transferFolio,
  isOrdersModalVisible: state => state.isOrdersModalVisible,
  isTransfersModalVisible: state => state.isTransfersModalVisible,
  isProductsByExcelModalVisible: state => state.isProductsByExcelModalVisible,
  isProductsByOrderModalVisible: state => state.isProductsByOrderModalVisible,
  fromOrder: state => state.fromOrder,
  catalog: state => state.catalog
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
